
<div
    class="credit {{ documentDirection }}"
    [ngClass]="viewType"
    *ngIf="isCreditEnabled && (availableCredits$ | async) as credit"
    routerLink="/credit-activity" 
>
    <div class="d-flex align-items-center credit-in" >
        <serviceos-ng-system-icon [icon]="'credits'"></serviceos-ng-system-icon>
        <span class="credit-value">{{ credit }}</span>
    </div>
    <div class="content" *ngIf="viewType === 'extended'">
        <ng-content #name></ng-content>
    </div>
</div>
